/**
 * @public
 */
export type PluralType = 'other' | 'zero' | 'one' | 'two' | 'few' | 'many';

/**
 * @public
 */
export type AltType = 'none' | 'short' | 'narrow' | 'variant' | 'stand-alone' | 'long' | 'menu';

/**
 * @public
 */
export type DayPeriodAltType = 'none' | 'casing';

/**
 * @public
 */
export type EraAltType = 'none' | 'sensitive';
